import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Aveți {{length}} alerte',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Informații de plată în verificare',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Informații de plată verificate',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Eroare informații de plată',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Informațiile dvs. de plată sunt revizuite de Stripe. Acest proces poate dura până la 48 de ore.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Informațiile dvs. de plată au fost verificate cu succes. Acum puteți primi plăți.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Se pare că a apărut o eroare cu informațiile dvs. Faceți clic aici pentru a actualiza informațiile.',
    },
  },
};
